<template>
  <div class="advice">
    <div class="advice__panel">
      <el-collapse-transition>
        <div class="advice__selected-flat" v-if="displayFlatType">
          <span class="advice__selected-flat__title">
            {{ $t('boxConfig.totalBoxToCarry') }}
          </span> <br/>
          {{ cartons.cartons_std }} {{ $t('boxConfig.standardBox') }} <br/>
          {{ cartons.cartons_livre }} {{ $t('boxConfig.booksBox') }} <br/>
          {{ cartons.cartons_penderie }} {{ $t('boxConfig.clothBox') }}
        </div>
      </el-collapse-transition>
      <el-collapse-transition>
        <div class="advice__basic-services" v-if="displayFixedAdvice">
          <div class="advice__basic-services__title">
            {{ fixedAdviceTitle }}
          </div>
          <div class="advice__basic-services__content">
            {{ fixedAdviceContent }}
          </div>
        </div>
      </el-collapse-transition>
      <el-collapse-transition>
          <div class="advice__content" v-if="hasAdvice">
            <div class="advice__content__header">
              <font-awesome-icon :icon="['fal', 'lightbulb-on']"
                class="advice__content__header__icon"
                @animationend="animateAdvice = false"
                :class="{animated: animateAdvice}" />
              <span class="advice__content__header__title">{{ $t(`base.advices`) }}</span>
            </div>
            <div class="advice__content__body">
              <div class="advice__content__body__title">
                {{$t(advice.content.title)}}
              </div>
              <img v-if="advice.content.image"
                   class="advice__content__body__image"
                   :class="{'big_height_only': isHeightLimited}"
                   :alt="advice.content.alt"
                   :src="advice.content.image"
              />
              <font-awesome-icon
                v-else-if="advice.content.icon"
                :icon="advice.content.icon"
                class="advice__content__body__icon"
                :class="{'big_height_only': isHeightLimited}" />
              <div class="advice__content__body__summary"
                   v-html="$t(advice.content.summary)">
              </div>
            </div>
            <button
              v-if="hasMoreInfo"
              class="advice__content__button"
              @click="showModal = true"
            >
              {{$t('base.learnMore')}}
            </button>
          </div>
      </el-collapse-transition>
    </div>
    <div class="advice__actions">
      <div v-if="enableSaveAndQuit"
           class="advice__actions__saveAndExit"
           @click="displaySaveAndQuit = true">
        <img class="advice__actions__saveAndExit__icon" :src="saveAndExitImg" alt="save and exit">
        <span class="advice__actions__saveAndExit__label">{{$t(`base.saveAndExit`)}}</span>
      </div>
    </div>
    <component
      v-if="hasMoreInfo"
      v-bind:is="advice.modal"
      :advice="advice"
      :visible.sync="showModal">
    </component>
    <save-and-quit-modal :visible.sync="displaySaveAndQuit"/>
  </div>
</template>
<script>
import AdviceModal from './modals/AdviceModal.vue';
import saveAndExit from '@/assets/img/saveAndExit.png';
import SaveAndQuitModal from './modals/SaveAndQuitModal.vue';
import '@/assets/scss/animations.scss';

export default {
  name: 'advice',
  components: {
    SaveAndQuitModal,
    AdviceModal,
  },
  props: {
    selectedPack: {
      type: String,
    },
  },
  data() {
    return {
      showModal: false,
      displaySaveAndQuit: false,
      animateAdvice: false,
      enableSaveAndQuit: false,
    };
  },
  computed: {
    advice() {
      return this.$store.getters['adviceStore/advice'];
    },
    hasAdvice() {
      return this.advice !== undefined
        && this.advice.content !== undefined
        && this.advice.content.title !== '';
    },
    hasMoreInfo() {
      return this.advice && this.advice.modal && this.advice.modal.length > 0;
    },
    saveAndExitImg() {
      return saveAndExit;
    },
    flatType() {
      return this.$store.getters['furnituresStore/flatType'];
    },
    cartons() {
      return this.$store.getters['furnituresStore/totalCarton'];
    },
    displayFlatType() {
      return this.$store.getters['routeStore/childRoute'].toLowerCase() === 'boxdelivery'
        && this.$store.getters['furnituresStore/totalBoxes'] > 0;
    },
    fixedAdviceContent() {
      return this.getFixedAdviceContent(this.$route.name, 'content');
    },
    fixedAdviceTitle() {
      return this.getFixedAdviceContent(this.$route.name, 'title');
    },
    displayFixedAdvice() {
      return this.$route.name === 'serviceOfferServices'
        || this.$route.name === 'serviceOfferAssurance';
    },
    isHeightLimited() {
      return this.displayFlatType || this.displayFixedAdvice;
    },
  },
  methods: {
    getFixedAdviceContent(content, contentType) {
      return this.$t(`advice.fixedAdvices.${content}.${contentType}`);
    },
  },
  watch: {
    advice() {
      this.animateAdvice = this.hasAdvice;
    },
  },
};
</script>
<style lang="scss">
  .advice ul {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      margin: 5px 0;
    }

    li:before {
      content: '•';
      position: relative;
      left: -4px;
    }
  }
</style>
<style scoped lang="scss">
  .advice {
    align-content: center;
    height: 100%;
    display: grid;
    grid-template-rows: 1fr 75px;

    &__panel {
      padding: 16px;
    }

    &__selected-flat{
      display: grid;
      margin-bottom: 18px;
      background-color: rgba(28, 219, 161, 0.1);
      border: 1px solid #1CDBA1;
      border-radius: $--border-radius-base;
      padding: 15px;
      &__title{
        font-weight: $--font-weight-500;
      }
    }

    &__basic-services{
      display: grid;
      margin-bottom: 18px;
      background-color: rgba(28, 219, 161, 0.1);
      border: 1px solid #1CDBA1;
      border-radius: $--border-radius-base;
      padding: 15px;
      &__title{
        font-weight: $--font-weight-500;
        margin-bottom: 10px;
      }
      &__content{
        font-size: 17px;
      }
    }

    &__content {
      display: block;
      max-height: 100%;
      height: fit-content;
      padding: 15px;
      background-color: $--color-light-grey-blue;
      border-radius: $--border-radius-base;
      text-align: center;

      &__header {
        display: grid;
        grid-template-columns: 58px auto;
        justify-items: start;
        align-items: center;

        &__icon {
          width: 42px;
          height: 42px;

          &.animated {
            animation: bounce-in .6s;
          }
        }

        &__title {
          font-weight: $--font-weight-500;
          font-size: 19px;
          line-height: 24px;
        }
      }

      &__body {
        height: fit-content;
        text-align: start;
        overflow: hidden;
        text-overflow: ellipsis;

        &__image {
          display: block;
          max-width: 50%;
          margin: 20px auto 15px auto;
        }

        &__icon {
          display: block;
          width: 60px;
          height: 60px;
          margin: 20px auto 15px auto;
        }

        .big_height_only {
          @media (max-height: 750px) {
            display: none;
          }
        }

        &__title {
          font-weight: $--font-weight-500;
          margin: 15px 0;
        }

        &__summary {
          font-size: 17px;
        }
      }

      &__button {
        text-align: center;
        margin-top: 15px;
        border-radius: $--border-radius-base;
        font-weight: bold;
        color: $--color-secondary;
        cursor: pointer;
        border: 1px solid $--color-secondary;
        width: 160px;
        height: 42px;
      }
    }

    &__actions {
      cursor: pointer;
      place-self: center;
      align-items: center;

      &__saveAndExit {
        display: flex;
        place-items: center;
        align-items: center;

        &__icon {
          padding: .4em;
        }

        &__label {
          font-size: 16px;
          font-weight: $--font-weight-500;
        }
      }
    }
  }
</style>
